import Icon from "@chakra-ui/icon"
import { Flex, Heading, Link, ListItem, OrderedList, Stack, Text } from "@chakra-ui/layout"
import React from "react"
import PensilLeftIcon from "../../assets/pencil-left.svg"
import num1Image from "../../images/num1.png"
import num2Image from "../../images/num2.png"
import num3Image from "../../images/num3.png"
import medal from "../../images/medal-konkurs.png"
import { Img } from "@chakra-ui/image"
import { Button } from "@chakra-ui/button"
import { ExternalLinkIcon } from "@chakra-ui/icons"

const data = [
    {
        img: num1Image,

        content: `👋 ПАЖЊА, ПАЖЊА: СРЕДЊОШКОЛЦИ, БУДИТЕ КРЕАТИВНИ, ЗАБАВИТЕ СЕ И ОСВОЈИТЕ ВРЕДНЕ НАГРАДЕ!📱<br/><br/>
            Снимите видео на тему “Знањем мењамо све(т)“ и освојите: <b>телефон Samsung Galaxy
            S20, телефон Samsung Galaxy A52s или телефон Samsung Galaxy A32</b>. <br/><br/> Снимите видео у трајању до једног минута (1:00). Видео материјалом прикажите свог наставника или наставницу који вас инспирише и мотивише да знањем промените свет! Будите креативни у начину на који ћете то приказати. Не заборавите да у видео материјалу објасните свој став и опишете како и зашто вас одабрани наставник или наставница инспирише!`,
        bg: "_red",
    },
    {
        img: num2Image,

        content: `Видео поставите на својој Инстаграм страници уз обавезан таг на видеу @mpntr.rs и таг @eusrbija и обавезне #znanjemmenjamosvet #reformaobrazovanja #EUzaTebe. Не заборавите да напишете назив свог рада! Уколико видео нема све наведено, неће ући у избор за награде.❌ <br/> <br/>Један учесник има право да постави само 1 видео! <br/><br/>Публика гласа за свог фаворита!`,
        bg: "_blue",
    },
    {
        img: num3Image,

        content: `Гласање се завршава 31. октобра у 23:59h, када ћемо направити пресек – три видеа са највећим бројем лајкова❤ освајају награде!<br/> <br/>📣 ГЛАВНЕ НАГРАДЕ:`,
        bg: "_olive",
    },
]

const MainCompetition = () => {
    return (
        <Stack w="100%" maxW="3000px" minH="100vh" overflowX="hidden" spacing={[4, 6, 8]}>
            <Flex
                justify="space-between"
                w="100%"
                h={["60px", "80px", "80px", "147px"]}
                align="center"
                my={["10px", "10px", "10px", "50px"]}
            >
                <Flex w={["26%", "32%"]} h="100%" align="flex-start">
                    <Icon
                        as={PensilLeftIcon}
                        w="100%"
                        h={["50px", "70px", "70px", "80px", "120px"]}
                    />
                </Flex>

                <Heading
                    fontSize={["28px", "32px", "38px", "74px", "98px"]}
                    fontWeight="900"
                    color="_olive"
                    textTransform="uppercase"
                    // minW={["220px", "290px", "unset"]}
                    textAlign="center"
                    pos="relative"
                >
                    КОНКУРС
                    <Img
                        src={medal}
                        objectFit="contain"
                        h={["140px", "170px", "360px"]}
                        right={["0"]}
                        bottom={["0"]}
                        transform={[
                            "translate(95%,80%)",
                            "translate(130%,90%)",
                            "translate(130%,90%)",
                            "translate(130%,90%)",
                            "translate(150%,90%)",
                        ]}
                        pos="absolute"
                        zIndex="10"
                    />
                </Heading>
                <Flex w={["26%", "32%"]} h="100%" align="flex-start">
                    <Icon
                        as={PensilLeftIcon}
                        w="100%"
                        h={["50px", "70px", "70px", "80px", "120px"]}
                        transform="rotateY(180deg)"
                    />
                </Flex>
            </Flex>
            {data.map((item, i) => {
                function createMarkup() {
                    return {
                        __html: item.content,
                    }
                }
                return (
                    <Flex
                        key={i}
                        w="100%"
                        h="100%"
                        px="3px"
                        justify={[i % 2 === 0 ? "flex-start" : "flex-end"]}
                        align={["flex-start", "flex-start", "flex-end"]}
                    >
                        <Stack
                            w={["100%", "65%", "65%", "52%"]}
                            minW={["253px", "300px", "400px"]}
                            maxW={["320px", "520px", "1000px"]}
                            h="100%"
                            minH={["100%", "100%", "432px"]}
                            bg={item.bg}
                            color="#fff"
                            px={["10px", "20px", "30px", "60px", "127px"]}
                            py={["15px", "15px", "40px"]}
                            pos="relative"
                            spacing={4}
                            align="center"
                            justify="center"
                            order={[i % 2 === 0 ? 1 : 2]}
                        >
                            <Text
                                fontSize={["13px", "14px", "16px", "16px", "18px"]}
                                maxW="570px"
                                w="100%"
                                zIndex="2"
                                lineHeight="180%"
                                dangerouslySetInnerHTML={createMarkup()}
                            ></Text>

                            {i === 2 && (
                                <>
                                    <OrderedList
                                        textAlign="left"
                                        w="100%"
                                        maxW="570px"
                                        fontSize={["13px", "14px", "16px", "16px", "18px"]}
                                        zIndex="10"
                                    >
                                        <Flex gridGap={["14px", "20px"]}>
                                            <span>🎉</span>
                                            <ListItem>награда: Samsung Galaxy S20</ListItem>
                                        </Flex>
                                        <Flex gridGap={["14px", "20px"]}>
                                            <span>🎉</span>
                                            <ListItem>награда: Samsung Galaxy A52s</ListItem>
                                        </Flex>
                                        <Flex gridGap={["14px", "20px"]}>
                                            <span>🎉 </span>
                                            <ListItem>награда: Samsung Galaxy A32</ListItem>
                                        </Flex>
                                    </OrderedList>

                                    <Stack w="100%" justify="flex-start" maxW="570px">
                                        <Link
                                            href={`/znanjem-menjamo-svet/Правила-и-услови-конкурса.pdf`}
                                            isExternal
                                            _hover={{
                                                textDecor: "none",
                                            }}
                                        >
                                            <Button
                                                w={["100%", "90%", "280px"]}
                                                mt="30px"
                                                bg="_blue"
                                                boxShadow="md"
                                                fontSize={["13px", "14px", "16px"]}
                                                rightIcon={<ExternalLinkIcon />}
                                                _hover={{
                                                    bg: "#3c858c",
                                                }}
                                                _active={{
                                                    bg: "#3c858c",
                                                }}
                                            >
                                                Правила и услови конкурса
                                            </Button>
                                        </Link>
                                        <Link
                                            href={`/znanjem-menjamo-svet/Продужење-периода-трајања-конкурса.pdf`}
                                            isExternal
                                            _hover={{
                                                textDecor: "none",
                                            }}
                                        >
                                            <Button
                                                w={["100%", "90%", "280px"]}
                                                bg="_red"
                                                boxShadow="md"
                                                fontSize={["13px", "14px", "16px"]}
                                                whiteSpace="normal"
                                                rightIcon={<ExternalLinkIcon />}
                                                _hover={{
                                                    bg: "#c9433c",
                                                }}
                                                _active={{
                                                    bg: "#c9433c",
                                                }}
                                            >
                                                Продужење периода трајања конкурса
                                            </Button>
                                        </Link>
                                        <Link
                                            href={`/znanjem-menjamo-svet/Победници-наградног-конкурса.pdf`}
                                            isExternal
                                            _hover={{
                                                textDecor: "none",
                                            }}
                                        >
                                            <Button
                                                w={["100%", "90%", "280px"]}
                                                bg="_yellow"
                                                boxShadow="md"
                                                whiteSpace="normal"
                                                fontSize={["13px", "14px", "16px"]}
                                                color="_olive"
                                                rightIcon={<ExternalLinkIcon />}
                                                _hover={{
                                                    bg: "#f68829",
                                                    color: "#fff",
                                                }}
                                                _active={{
                                                    bg: "#f68829",
                                                    color: "#fff",
                                                }}
                                            >
                                                Победници наградног конкурса
                                            </Button>
                                        </Link>
                                    </Stack>
                                </>
                            )}
                        </Stack>
                        <Img
                            src={item.img}
                            objectFit="contain"
                            h={["190px", "250px", "400px", "450px"]}
                            transform={[i % 2 === 0 ? "translate(-20px,0)" : "translate(20px,0)"]}
                            order={[i % 2 === 0 ? 2 : 1]}
                        />
                    </Flex>
                )
            })}
        </Stack>
    )
}

export default MainCompetition
